var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"square-with-icon",style:({ backgroundColor: _vm.colorComputed })},[_c('va-icon',{attrs:{"name":_vm.iconClass}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }